import type {RouteWithSlug} from "../types";

/**
 * Generic page route with single slug
 * Used for simple content pages like: /[slug]
 *
 * Examples:
 * - /about-us
 * - /privacy-policy
 * - /terms-of-service
 */
export const pageRoute: RouteWithSlug = {
    path: "/[slug]",
    url: (slug: string) => `${slug.startsWith("/") ? "" : "/"}${slug}`,
};
